import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {EformService} from "../../../service/eform.service";

@Component({
   selector: 'app-currency',
   templateUrl: './currency.component.html',
   styleUrls: ['./currency.component.css'],
})
export class CurrencyComponent implements OnInit {
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() fieldName: any;
   @Input() labelName: any;
   @Input() hideHeader: boolean = false;
   maxLengthNumber = 12;
   decimal: any;
   placeholder: string;
   number: any;
   rangeStart: any;
   rangeEnd: any;
   value: any;
   isInvalid = false;
   pasteError = false;

   constructor(private eformService: EformService, private ref: ChangeDetectorRef) {
   }

   ngOnInit(): void {
      this.value = this.eformService.eForm.value.value && this.eformService.eForm.value.value[this.fieldName] ? this.eformService.eForm.value.value[this.fieldName] : this.value;
      this.rangeStart = this.field.rangeStart.toString().replace(/,/g, '');
      this.rangeEnd = this.field.rangeEnd.toString().replace(/,/g, '');
      this.placeholder = this.field.currency;
      if (this.field.required && this.field.rangeStart !== '' && this.field.rangeEnd !== '') {
         this.form.controls[this.fieldName].setValidators([Validators.required, this.range(Number(this.rangeStart), Number(this.rangeEnd)),
            Validators.pattern('')]);
      }
      if (this.field.rangeStart !== '' && this.field.rangeEnd !== '') {
         this.form.controls[this.fieldName].setValidators([this.range(Number(this.rangeStart), Number(this.rangeEnd)),
            Validators.pattern('')]);
      }
   }

   range(min: number, max: number): ValidatorFn {
      return (c: AbstractControl): { [key: string]: boolean } | null => {
         if (c.value) {
            let value = c.value.toString().replace(this.field.currency, '');
            value = value.replace(/\s/g, '');
            value = value.replace(/,/g, '');
            value = value.replace(/ /g,'');
            value = Number(value);
            if (isNaN(value) || value.length > this.maxLengthNumber) {
               return {'invalid': true};
            }
            if (value && (isNaN(value) || value < min || value > max)) {
               return {'range': true};
            }
         }
         return null;
      };
   }

   onFocus(event) {
      this.isInvalid = false;
      let value = event.value.replace(this.field.currency, '')
      value = value.replace(/ /g,'');
      value = value.replace(/,/g, '');
      this.form.controls[this.fieldName].setValue(value);
      if (!this.pasteError) {
         this.form.get(this.fieldName).setErrors({invalid: true});
      }
   }

   onBlur(event) {
      if (!this.pasteError) {
         this.form.get(this.fieldName).setErrors({invalid: true});
         return;
      }
      let isInvalidInput = false;
      let value = event.value.replace(this.field.currency, '');
      if (value.trim() === '') {
         this.field.subType !== 'suffix' ? this.form.controls[this.fieldName].setValue('')
         : this.form.controls[this.fieldName].setValue('');
         return;
      }
      value = value.replace(/\s/g, '');
      value = value.replace(/,/g, '');
      value = value.replace(/ /g,'');
      value = value.replace(/^0+(?=[1-9])/g, '');
      value = value.replace(/^-?0+(?=[1-9])/g, '-');
      value = Number(value) === 0 ? '0' : value;
      if (event.value.indexOf('.') === -1) {
         if (isNaN(value)) {
            this.number = value;
            isInvalidInput = true;
         }
         this.number = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
         this.number = Number(Math.round((parseFloat(value) + Number.EPSILON) * 100) / 100).toFixed(2);
         if (isNaN(this.number)) {
            this.number = value;
            isInvalidInput = true;
            this.number = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
         } else {
            const splNumber = this.number.toString().split('.')[0];
            const splDecimal = this.number.toString().split('.')[1];
            this.number = splNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + splDecimal;
         }
      }
      this.field.subType !== 'suffix' ? this.form.controls[this.fieldName].setValue(this.field.currency + ' ' + this.number)
         : this.form.controls[this.fieldName].setValue(this.number + ' ' + this.field.currency);
      if (isInvalidInput || this.invalidMaxLength(event.value)) {
         this.form.get(this.fieldName).setErrors({invalid: true});
      }
      let invalid = this.form.get(this.fieldName).status === 'INVALID';
      if (!invalid) {
         this.form.get(this.fieldName).setErrors(null);
      }
   }

   onPaste(event): void {
      const regex = /^-?\d{0,3}(,\d{3})*\.?(\d+)?$/;
      const pastedText = event.clipboardData?.getData('text') || '';
      this.pasteError = regex.test(pastedText);
      if (!this.pasteError || this.invalidMaxLength(pastedText)) {
         this.form.get(this.fieldName).setErrors({invalid: true});
      }
   }

   onInput(event): void {
      const regex = /^-?\d{0,3}(,\d{3})*\.?(\d+)?$/;
      const val = event.target.value;
      this.pasteError = regex.test(val);
      if (!this.pasteError|| this.invalidMaxLength(val)) {
         this.form.get(this.fieldName).setErrors({invalid: true});
      }
   }

   invalidMaxLength(value: string): boolean {
      let val = value.toString().replace(this.field.currency, '');
      val = val.replace(/\s/g, '');
      val = val.replace(/,/g, '');
      val = val.replace(/ /g,'');
      let val2 = Number(val);
      if (isNaN(val2) || val.length > this.maxLengthNumber) {
         return true;
      }
      return false;
   }

   isEmpty(value: any): boolean {
      return value == null || value === '';
   }

   disableRightClick(event) {
      event.preventDefault();
   }

   checkValidateField(field) {
      if (this.form.get(field).hasValidator(Validators.required)) {
         return true;
      } else {
         return false;
      }
   }
}
